export default "__VITE_ASSET__xNq9Arew__"